export const DOSSIER_CREATE_PATH_TYPES = {
  NUMERO_COMMANDE: 'numero_commande',
  INFO_PRODUIT: 'info_produit',
  CODE_BARRES: 'code_barres',
  RECHERCHE_CLIENT: 'recherche_client',
} as const;

export type DossierCreatePathType =
  (typeof DOSSIER_CREATE_PATH_TYPES)[keyof typeof DOSSIER_CREATE_PATH_TYPES];
